import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { services } from "@/mocks/home";

const featuredAreas = ["Nagarabhavi", "Jayanagar", "HSR Layout", "Whitefield", "Marathahalli"];

export default function ServicesSection() {
  return (
    <section id="services" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Our Services"
          title="What We Do?"
          subtitle="We offer a wide platform to the people to get the best services from us to relocate their Home and Office."
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => {
            const featured = Boolean(service.featured);
            const cardClass = `group flex flex-col rounded-lg p-6 transition-colors ${
              featured
                ? "bg-primary-500"
                : "border border-background-200 bg-background-50 hover:border-primary-300"
            }`;
            const inner = (
              <>
                <span
                  className={`flex h-14 w-14 items-center justify-center rounded-lg transition-colors ${
                    featured
                      ? "bg-background-50/15 text-background-50"
                      : "bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50"
                  }`}
                >
                  <i className={`${service.icon} text-3xl`} />
                </span>
                <h3
                  className={`mt-5 font-heading text-base font-semibold md:text-lg ${
                    featured ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {service.title}
                </h3>
                <p className={`mt-3 text-sm leading-relaxed ${featured ? "text-background-100" : "text-foreground-600"}`}>
                  {service.description}
                </p>
                {featured && (
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {featuredAreas.map((area) => (
                      <span
                        key={area}
                        className="rounded-full bg-background-50/15 px-2.5 py-0.5 text-xs font-medium text-background-50"
                      >
                        {area}
                      </span>
                    ))}
                  </div>
                )}
                {service.href && (
                  <span
                    className={`mt-auto inline-flex items-center gap-2 pt-5 text-sm font-semibold ${
                      featured ? "text-background-50" : "text-primary-600"
                    }`}
                  >
                    {featured ? "Explore local shifting" : "View details"}
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                )}
              </>
            );
            return service.href ? (
              <Link key={service.title} to={service.href} className={cardClass}>
                {inner}
              </Link>
            ) : (
              <div key={service.title} className={cardClass}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}